<template>
  <div class="vacancies">
    <div class="main-wrapper">
      <layout-header></layout-header>
      <layout-sidebar></layout-sidebar>
      <!-- Page Wrapper -->
      <div class="page-wrapper">
        <!-- Page Content -->
        <div class="content container-fluid">
          <!-- Page Header -->
          <div class="page-header">
            <div class="d-flex justify-content-between">
              <div class="col">
                <h3 class="page-title">Performance Journals</h3>
                <ul class="breadcrumb">
                  <li class="breadcrumb-item active">Performance Journals</li>
                </ul>
              </div>
            </div>
          </div>
          <!-- /Page Header -->

          <div class="row">
            <div class="col-md-12">
                <div class="col-md-12">
                <div
                  class="alert alert-danger alert-dismissible fade show"
                  role="alert"
                  v-if="error"
                >
                  <strong>Error!</strong> {{ error }}
                  <button
                    type="button"
                    class="close"
                    data-dismiss="alert"
                    aria-label="Close"
                  >
                    <span aria-hidden="true">&times;</span>
                  </button>
                </div>
              </div>
              <div class="col-md-12">
                <div
                  class="alert alert-success alert-dismissible fade show"
                  role="alert"
                  v-if="message"
                >
                  <strong>Success!</strong> {{ message }}
                  <button
                    type="button"
                    class="close"
                    data-dismiss="alert"
                    aria-label="Close"
                  >
                    <span aria-hidden="true">&times;</span>
                  </button>
                </div>
              </div>
              <div class="col-md-12">
                <div class="accordion" id="accordionExample">
                  <div class="card mb-3">
                    <div class="card-header" id="headingOne">
                      <h5
                        class="mb-0 d-flex justify-content-between collapsed"
                        data-toggle="collapse"
                        data-target="#collapseOne"
                        aria-expanded="true"
                        aria-controls="collapseOne"
                      >
                        <button class="btn collapsed">
                          General
                        </button>
                        <span class="collapsed">
                          <i class="la la-chevron-down icon-dropdown"></i>
                        </span>
                      </h5>
                    </div>

                    <div
                      id="collapseOne"
                      class="collapse show"
                      aria-labelledby="headingOne"
                      data-parent="#accordionExample"
                    >
                      <div class="card-body mt-1">
                        <form @submit.prevent="onSubmit">
                          <div class="d-flex justify-content-between mt-1">
                            <div></div>
                            <button class="btn text-primary float-right mr-3">
                              <i class="la la-check"></i> Save
                            </button>
                          </div>
                          <hr class="mt-1" />

                          <div class="row">
                            <div class="col-md-8">
                              <div class="form-group">
                                <label>
                                  Title <span class="text-danger">*</span>
                                </label>
                                <input
                                  type="text"
                                  v-model.trim="$v.title.$model"
                                  class="form-control"
                                  :class="{
                                    'is-invalid': submitted && $v.title.$error
                                  }"
                                />
                              </div>
                            </div>
                            <div class="col-md-4">
                              <div class="form-group">
                                <label
                                  >Employee
                                  <span class="text-danger">*</span></label
                                >
                                <select
                                  placeholder="Select Employee"
                                  class="form-control"
                                  v-model.trim="$v.employeeId.$model"
                                  :class="{
                                    'is-invalid':
                                      submitted && $v.employeeId.$error
                                  }"
                                >
                                  <option disabled>Select Staff</option>
                                  <option
                                    v-for="member in employees"
                                    :key="member.id"
                                    :value="member.id"
                                  >
                                    {{
                                      member.lastName + " " + member.firstName
                                    }}
                                  </option>
                                </select>
                              </div>
                            </div>
                          </div>
                          <div class="row">
                            <div class="col-md-12">
                              <div class="form-group">
                                <label
                                  >Description
                                  <span class="text-danger">*</span></label
                                >
                                <textarea
                                  type="text"
                                  rows="5"
                                  cols="7"
                                  class="form-control"
                                  v-model.trim="$v.description.$model"
                                  :class="{
                                    'is-invalid':
                                      submitted && $v.description.$error
                                  }"
                                >
                                </textarea>
                              </div>
                            </div>
                          </div>
                          <div class="row">
                            <div class="col-md-3">
                              <div class="form-group">
                                <label>
                                  Start Date <span class="text-danger">*</span>
                                </label>
                                <div class="cal-icon">
                                  <datepicker
                                    calendar-class
                                    input-class
                                    bootstrap-styling
                                    class="datetimepicker"
                                    type="text"
                                    v-model.trim="$v.startDate.$model"
                                    :class="{
                                      'is-invalid':
                                        submitted && $v.startDate.$error
                                    }"
                                  />
                                </div>
                              </div>
                            </div>
                            <div class="col-md-3">
                              <div class="form-group">
                                <label>
                                  Date Completed
                                  <span class="text-danger">*</span>
                                </label>
                                <div class="cal-icon">
                                  <datepicker
                                    calendar-class
                                    input-class
                                    bootstrap-styling
                                    class="datetimepicker"
                                    type="text"
                                    v-model.trim="$v.dateCompleted.$model"
                                    :class="{
                                      'is-invalid':
                                        submitted && $v.dateCompleted.$error
                                    }"
                                  />
                                </div>
                              </div>
                            </div>

                            <div class="col-md-1">
                              <div class="form-group">
                                <label>
                                  Share <span class="text-danger">*</span>
                                </label>

                                <div class="onoffswitch">
                                  <input
                                    type="checkbox"
                                    v-model="share"
                                    name="onoffswitch"
                                    class="onoffswitch-checkbox"
                                    id="switch_share"
                                    checked
                                  />
                                  <label
                                    class="onoffswitch-label"
                                    for="switch_share"
                                  >
                                    <span class="onoffswitch-inner"></span>
                                    <span class="onoffswitch-switch"></span>
                                  </label>
                                </div>
                              </div>
                            </div>
                          </div>
                        </form>
                      </div>
                    </div>
                  </div>
                  <div class="card mb-3">
                    <div class="card-header" id="headingTwo">
                      <h5
                        class="mb-0 d-flex justify-content-between collapsed"
                        data-toggle="collapse"
                        data-target="#collapseTwo"
                        aria-expanded="false"
                        aria-controls="collapseTwo"
                      >
                        <button
                          class="btn collapsed"
                          data-toggle="collapse"
                          data-target="#collapseTwo"
                          aria-expanded="false"
                          aria-controls="collapseTwo"
                        >
                          Comments
                        </button>
                        <span
                          class="collapsed"
                          type="button"
                          data-toggle="collapse"
                          data-target="#collapseTwo"
                          aria-expanded="false"
                          aria-controls="collapseTwo"
                        >
                          <i class="la la-chevron-down icon-dropdown"></i>
                        </span>
                      </h5>
                    </div>

                    <div
                      id="collapseTwo"
                      class="collapse"
                      aria-labelledby="headingTwo"
                      data-parent="#accordionExample"
                    >
                      <div class="card-body">
                        <div class="row">
                          <a
                            @click="openDialogComment"
                            v-if="journalId"
                            class="btn text-primary ml-3"
                          >
                            <i class="la la-plus"></i> Add
                          </a>
                        </div>
                        <hr />
                        <div
                          class="row  ml-3"
                          v-for="item in journalComments"
                          :key="item.id"
                        >
                          <div class="col-md-12">
                            <span style="color: #023e8a"
                              >{{
                                new Date(item.createdAt).toLocaleDateString()
                              }}
                              {{
                                item.employee.firstName +
                                  " " +
                                  item.employee.lastName
                              }}
                            </span>
                          </div>
                          <div class="col-md-12">
                            <span v-html="item.comment"></span>
                          </div>
                        </div>
                        <!-- Add Measurement Modal -->
                        <v-dialog v-model="dialogComment" max-width="725px">
                          <div class="modal-content">
                            <div class="modal-header">
                              <h5 class="modal-title">Add Comment</h5>
                              <button
                                type="button"
                                class="close"
                                @click="closeComment"
                              >
                                <span aria-hidden="true">&times;</span>
                              </button>
                            </div>
                            <div class="modal-body">
                              <div class="col-xs-6 col-md-12 p-0 pl-sm-2">
                                <div class="job-card">
                                  <quill-editor
                                    v-model="comment"
                                    ref="myQuillEditor"
                                    :options="editorOption"
                                  >
                                  </quill-editor>
                                  <div class="submit-section">
                                    <button
                                      class="btn btn-primary submit-btn"
                                      @click="addComment"
                                    >
                                      Submit
                                    </button>
                                  </div>
                                </div>
                              </div>
                            </div>
                          </div>
                        </v-dialog>
                        <!-- /Add Measurement Modal -->
                      </div>
                    </div>
                  </div>

                  <div class="card mb-3">
                    <div class="card-header" id="headingFour">
                      <h5
                        class="mb-0 d-flex justify-content-between"
                        type="button"
                        data-toggle="collapse"
                        data-target="#collapseFour"
                        aria-expanded="false"
                        aria-controls="collapseFour"
                      >
                        <button class="btn collapsed">
                          Attachments ({{ journalAttachments.length }})
                        </button>
                        <span class="collapsed">
                          <i class="la la-chevron-down icon-dropdown"></i>
                        </span>
                      </h5>
                    </div>
                    <div
                      id="collapseFour"
                      class="collapse"
                      aria-labelledby="headingFour"
                      data-parent="#accordionExample"
                    >
                      <div class="card-body">
                        <div class="row" v-if="this.journalId">
                          <a
                            @click="openDialogAttachment"
                            class="btn text-primary ml-3"
                          >
                            <i class="la la-plus"></i> Add
                          </a>
                        </div>
                        <hr />

                        <div class="row">
                          <div class="col-md-12">
                            <div class="table-responsive">
                              <table
                                class="table table-striped custom-table mb-0 datatable"
                              >
                                <tbody>
                                  <tr
                                    v-for="item in journalAttachments"
                                    :key="item.id"
                                  >
                                    <td>
                                      <img
                                        alt=""
                                        :src="
                                          generateDocumentImage(item.document)
                                        "
                                        width="30"
                                      />
                                      <td></td>
                                      <td>{{ item.title }}</td>
                                    </td>

                                    <td>
                                      {{
                                        new Date(item.createdAt).toDateString()
                                      }}
                                    </td>
                                    <td class="text-right">
                                      <a
                                        class="dropdown-item"
                                        v-if="item.document"
                                        @click="
                                          getAttachDocument(item.document)
                                        "
                                        ><i class="fa fa-download m-r-5"></i>
                                        Download</a
                                      >
                                    </td>
                                    <td class="text-right">
                                      <a
                                        class="dropdown-item"
                                        @click="openDeleteAttachment(item)"
                                        data-toggle="modal"
                                        data-target="#delete_policy"
                                        ><i class="fa fa-trash-o m-r-5"></i>
                                        Delete</a
                                      >
                                    </td>
                                  </tr>
                                </tbody>
                              </table>
                            </div>
                          </div>
                        </div>
                        <!-- Add Activity Modal -->
                        <v-dialog v-model="dialogAttachment" max-width="725px">
                          <div class="modal-content">
                            <div class="modal-header">
                              <h5 class="modal-title">Add Attachment</h5>
                              <button
                                type="button"
                                class="close"
                                @click="closeAttachment"
                              >
                                <span aria-hidden="true">&times;</span>
                              </button>
                            </div>
                            <div class="modal-body">
                              <form @submit.prevent="onSubmitAttachment">
                                <div class="row">
                                  <div class="col-md-12">
                                    <div
                                      class="alert alert-danger alert-dismissible fade show"
                                      role="alert"
                                      v-if="error"
                                    >
                                      <strong>Error!</strong> {{ error }}
                                      <button
                                        type="button"
                                        class="close"
                                        data-dismiss="alert"
                                        aria-label="Close"
                                      >
                                        <span aria-hidden="true">&times;</span>
                                      </button>
                                    </div>
                                  </div>
                                  <div class="col-md-12">
                                    <div
                                      class="alert alert-success alert-dismissible fade show"
                                      role="alert"
                                      v-if="message"
                                    >
                                      <strong>Success!</strong> {{ message }}
                                      <button
                                        type="button"
                                        class="close"
                                        data-dismiss="alert"
                                        aria-label="Close"
                                      >
                                        <span aria-hidden="true">&times;</span>
                                      </button>
                                    </div>
                                  </div>
                                </div>
                                <div class="row">
                                  <div class="col-sm-12">
                                    <div class="row">
                                      <div class="col-md-12">
                                        <div class="form-group">
                                          <label
                                            >Title
                                            <span class="text-danger"
                                              >*</span
                                            ></label
                                          >
                                          <input
                                            v-model="attachmentTitle"
                                            class="form-control"
                                          />
                                        </div>
                                      </div>
                                      <div class="col-md-12">
                                        <div class="form-group">
                                          <label>Upload Policy</label>
                                          <div class="custom-file" v-if="!file">
                                            <input
                                              type="file"
                                              class="custom-file-input"
                                              id="cv_upload"
                                              @change="onFilePicked"
                                            />
                                            <label
                                              class="custom-file-label"
                                              for="cv_upload"
                                              >Choose file</label
                                            >
                                          </div>
                                          <div class="row" v-if="file">
                                            <div class="col-md-6">
                                              <span>{{ fileName }}</span>
                                            </div>
                                            <div class="col-md-6">
                                              <a
                                                class="btn btn-primary"
                                                @click="changeFile"
                                                >Change File</a
                                              >
                                            </div>
                                          </div>
                                        </div>
                                      </div>
                                    </div>
                                  </div>
                                </div>
                                <div class="submit-section">
                                  <button class="btn btn-primary submit-btn">
                                    Submit
                                  </button>
                                </div>
                              </form>
                            </div>
                          </div>
                        </v-dialog>
                        <!-- /Add Activity Modal -->
                        <v-dialog
                          v-model="dialogDeleteAttachment"
                          max-width="725px"
                        >
                          <div class="modal-content">
                            <div class="modal-body">
                              <div class="form-header">
                                <h3>Delete</h3>
                                <p>Are you sure want to delete this?</p>
                              </div>
                              <div class="modal-btn delete-action">
                                <div class="row">
                                  <div class="col-6">
                                    <a
                                      class="btn btn-primary continue-btn"
                                      @click="onDeleteAttachment"
                                      >Delete</a
                                    >
                                  </div>
                                  <div class="col-6">
                                    <a
                                      class="btn btn-primary cancel-btn"
                                      @click="closeDeleteAttachment"
                                      >Cancel</a
                                    >
                                  </div>
                                </div>
                              </div>
                            </div>
                          </div>
                        </v-dialog>
                      </div>
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div>
          <!-- /Page Content -->
        </div>
        <v-dialog max-width="725px">
          <div class="modal-content">
            <div class="modal-body">
              <div class="form-header">
                <h3>Delete</h3>
                <p>Are you sure want to delete this?</p>
              </div>
              <div class="modal-btn delete-action">
                <div class="row">
                  <div class="col-6">
                    <a class="btn btn-primary continue-btn" data-dismiss="modal"
                      >Delete</a
                    >
                  </div>
                  <div class="col-6">
                    <a class="btn btn-primary cancel-btn">Cancel</a>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </v-dialog>
      </div>
      <!-- /Page Wrapper -->
    </div>
  </div>
</template>
<script>
import LayoutHeader from "@/components/layouts/Header.vue";
import LayoutSidebar from "@/components/layouts/Sidebar.vue";
import { authenticationService } from "@/services/authenticationService";
import { performanceService } from "@/services/performanceService";
import { employeeService } from "@/services/employeeService";
import { organizationService } from "@/services/organizationService";
import { required, sameAs } from "vuelidate/lib/validators";
import Datepicker from "vuejs-datepicker";

export default {
  components: {
    LayoutHeader,
    LayoutSidebar,
    Datepicker
  },
  props: {
    settings: {}
  },
  computed: {
    editor() {
      return this.$refs.myQuillEditor.quill;
    }
  },
  data() {
    return {
      editorOption: {},
      switch1: true,
      dialogComment: false,
      dialogAttachment: false,
      dialogDeleteAttachment: false,
      journalId: this.$route.params.id,
      company: authenticationService.currentOfficeValue,
      currentUser: authenticationService.currentUserValue,
      attachment: {},
      submitted: false,
      loading: false,
      error: "",
      comment: "",
      title: "",
      attachmentTitle: "",
      description: "",
      employeeId: null,
      journalDate: new Date(),
      startDate: null,
      dateCompleted: null,
      share: false,
      submittedBy: "",
      source: 0,
      journalComments: [],
      journalAttachments: [],
      employees: [],
      file: null,
      fileName: null,
      message: "",
      error: ""
    };
  },

  validations: {
    title: { required },
    description: { required },
    startDate: { required },
    dateCompleted: { required },
    employeeId: { required }
  },
  mounted() {
    this.getJournal();
    this.getEmployees();
    this.$emit("update:settings", this.settings);

    if ($(".datatable").length > 0) {
      $(".datatable").DataTable({
        bFilter: false
      });
    }
  },

  methods: {
    onFilePicked(event) {
      const files = event.target.files;
      this.fileName = files[0].name;
      this.file = files[0];
    },

    changeFile() {
      this.file = null;
      this.fileName = "";
    },
    getJournal() {
      performanceService.getJournal(this.journalId).then(
        model => {
          (this.title = model.title),
            (this.description = model.description),
            (this.startDate = model.startDate),
            (this.dateCompleted = model.dateCompleted),
            (this.journalDate = model.journalDate),
            (this.source = model.source),
            (this.employeeId = model.employeeId),
            (this.share = model.share),
            (this.submittedBy = model.submittedBy),
            (this.journalComments = model.journalComments),
            (this.journalAttachments = model.journalAttachments);

          console.log(model);
        },
        error => {
          error = error;
        }
      );
    },
    getEmployees() {
      employeeService.getEmployees(this.company.id).then(
        model => {
          this.employees = model;
          // console.log(model);
        },
        error => {
          error = error;
        }
      );
    },
    onSubmit() {
      this.submitted = true;

      this.$v.$touch();
      if (this.$v.$invalid) {
        return;
      }
      this.loading = true;
      if (this.journalId) {
        performanceService
          .updateJournal(
            this.journalId,
            0,
            this.employeeId,
            this.title,
            this.description,
            this.journalDate,
            this.source,
            this.startDate,
            this.dateCompleted,
            this.share,
            this.submittedBy
          )
          .then(m => {
            this.message = "Journal updated successfully";
            this.getJournal();
          });
      } else {
        performanceService
          .addJournal(
            0,
            this.employeeId,
            this.title,
            this.description,
            this.journalDate,
            this.source,
            this.startDate,
            this.dateCompleted,
            this.share,
            this.currentUser.employee.firstName +
              " " +
              this.currentUser.employee.lastName
          )
          .then(m => {
            this.journalId = m;
            this.message = "Journal created successfully";
            this.getJournal();
          });
      }
    },
    onSubmitAttachment() {
      performanceService
        .addJournalAttachment(
          0,
          this.journalId,
          this.attachmentTitle,
          this.file,
          this.company.id
        )
        .then(
          model => {
            (this.attachmentTitle = ""),
              (this.file = null),
              (this.fileName = "");
            this.closeAttachment();
            this.getJournal();
          },
          error => {
            this.error = error;
          }
        );
    },
    addComment() {
      performanceService
        .addJournalComment(
          0,
          this.journalId,
          this.comment,
          this.currentUser.employee.id
        )
        .then(m => {
          this.getJournal();
        });
    },
    onDeleteAttachment() {
      performanceService
        .removeGoalAttachment(this.attachment.id)
        .then(model => {
          this.getJournal();
          this.closeDeleteAttachment();
        });
    },
    getAttachDocument(file) {
      organizationService.getPolicyDocument(file).then(
        model => {
          let blob = new Blob([model.data], { type: model.data.type });
          // For the processing of the IE browser, CreateObjectURL is not supported by some IE browser
          if (window.navigator && window.navigator.msSaveOrOpenBlob) {
            window.navigator.msSaveOrOpenBlob(blob, model.fileName);
          } else {
            var downloadElement = document.createElement("a");
            var href = window.URL.createObjectURL(blob); // Create a download link
            downloadElement.href = href;
            downloadElement.download = model.fileName; // Download the file name
            document.body.appendChild(downloadElement);
            downloadElement.click(); // click to download
            document.body.removeChild(downloadElement); // Download complete removal element
            window.URL.revokeObjectURL(href); // Release Blob object
          }
        },
        error => {
          error = error;
        }
      );
    },
    generateDocumentImage(file) {
      var splitFile = file.split("\\");
      var fileName = splitFile[splitFile.length - 1];
      var contentType = fileName.split(".")[1];
      switch (contentType) {
        case "aspx":
          return require("../../assets/document/asp-file-format.png");
        case "bak":
          return require("../../assets/document/bak-file-format.png");
        case "csv":
          return require("../../assets/document/csv-file-format.png");
        case "xlsx":
          return require("../../assets/document/csv-file-format.png");
        case "docx":
          return require("../../assets/document/doc-file-format.png");
        case "doc":
          return require("../../assets/document/doc-file-format.png");
        case "html":
          return require("../../assets/document/html-file-format.png");
        case "log":
          return require("../../assets/document/log-file-format.png");
        case "ods":
          return require("../../assets/document/ods-file-format.png");
        case "pdf":
          return require("../../assets/document/pdf-file-format.png");
        case "png":
          return require("../../assets/document/png-file-format.png");
        case "zip":
          return require("../../assets/document/zip-file-format.png");
      }
    },
    onEditorChange({ quill, html, text }) {
      // console.log("editor change!", quill, html, text);
      this.content = html;
    },
    onEditorChange1({ quill, html, text }) {
      // console.log("editor change!", quill, html, text);
      this.content = html;
    },
    closeComment() {
      this.dialogComment = false;
    },
    closeAttachment() {
      this.dialogAttachment = false;
      // this.clearModel();
    },
    closeDeleteAttachment() {
      this.dialogDeleteAttachment = false;
      // this.clearModel();
    },
    openDeleteAttachment(item) {
      this.attachment = item;
      this.dialogDeleteAttachment = true;
    },
    openDialogAttachment() {
      this.message = "";
      this.error = "";
      this.dialogAttachment = true;
    },
    openDialogComment() {
      this.message = "";
      this.error = "";
      this.dialogComment = true;
    }
  },
  name: "addjournal"
};
</script>
<style scoped>
.datatable > thead > tr > th,
.datatable > tbody > tr > td {
  max-width: 100px;
  overflow: hidden;
  text-overflow: ellipsis;
  white-space: nowrap;
}
</style>



// WEBPACK FOOTER //
// src/components/performance/addJournal.vue